export const ADD_TOURNAMENT = 'ADD_TOURNAMENT'
export const DELETE_TOURNAMENT = 'DELETE_TOURNAMENT'
export const GET_TOURNAMENT = 'GET_TOURNAMENT'
export const SET_LOADING = 'SET_LOADING';
export const GET_TOURNAMENT_BY_ID = 'GET_TOURNAMENT_BY_ID';
export const GET_TOURNAMENTS_BY_SEARCH = 'GET_TOURNAMENTS_BY_SEARCH';
export const GET_DIVISION_BY_SEARCH = 'GET_DIVISION_BY_SEARCH';
export const ADD_DIVISION = 'ADD_DIVISION';
export const GET_DIVISION__Details_BY_SEARCH = 'GET_DIVISION__Details_BY_SEARCH';
export const UPDATE_TOURNAMENT = 'UPDATE_TOURNAMENT';
export const GET_ALL_DIVISIONS = 'GET_ALL_DIVISIONS';
export const DELETE_DIVISION = 'DELETE_DIVISION';
export const GET_DIVISION__DETAILS_BY_DIVISION_ID = 'GET_DIVISION__DETAILS_BY_DIVISION_ID';
export const DEFAULT_TOURNAMENTS = 'DEFAULT_TOURNAMENTS';
export const CLEAR_TOURNAMENT = 'CLEAR_TOURNAMENT';
export const GET_TOURNAMENT_DIVISIONS = 'GET_TOURNAMENT_DIVISIONS';